import Address from '@/models/common/address.js'
export default {
  data() {
    return {
      // 联级格式
      defaultParams: {
        label: "name",
        value: "name",
        children: "children"
      },
      // 省市列表
      provincesAndCitiesAddressList: [],
      // 直辖市code列表
      directlyAdministeredMunicipality: ['810000', '820000']
    }
  },
  created() {
    this.initProvincesAndCitiesAddressList()
  },
  methods: {
    /**
     * @desc 获取省市列表
     */
    initProvincesAndCitiesAddressList() {
      Address.getAddressMock().then(res => {
        let addressArr = eval('(' + res + ')')
        let arr = []
        addressArr.map(i => {
          let obj = {}
          obj.code = i.code
          obj.name = i.name
          if (this.directlyAdministeredMunicipality.indexOf(i.code) === -1) {
            obj.children = []
            i.children.map(j => {
              let obj2 = {}
              obj2.code = j.code
              obj2.name = j.name
              obj2.children = []
              j.children.map(p => {
                let obj3 = {}
                obj3.code = p.code
                obj3.name = p.name
                obj2.children.push(obj3)
              })
              obj.children.push(obj2)
            })
          }
          arr.push(obj)
        })
        this.provincesAndCitiesAddressList = arr
      })
    },
  }
}